import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "15",
      cy: "11.5",
      r: "8.5"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M10.5 18.7V27l4.5-2.8 4.5 2.8v-8.3M10.8 11.8l3 3 5.4-6" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }